/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Verify_Email_ButtonInputs */

const en_verify_email_button = /** @type {(inputs: Verify_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verify email address`)
};

const id_verify_email_button = /** @type {(inputs: Verify_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifikasi alamat email`)
};

const ms_verify_email_button = /** @type {(inputs: Verify_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sahkan alamat e-mel`)
};

const ca_verify_email_button = /** @type {(inputs: Verify_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificar adreça de correu electrònic`)
};

const cs_verify_email_button = /** @type {(inputs: Verify_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ověřit e-mailovou adresu`)
};

const da_verify_email_button = /** @type {(inputs: Verify_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekræft e-mailadresse`)
};

const de_verify_email_button = /** @type {(inputs: Verify_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail-Adresse verifizieren`)
};

const et_verify_email_button = /** @type {(inputs: Verify_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kinnita e-posti aadress`)
};

const es_verify_email_button = /** @type {(inputs: Verify_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificar correo electrónico`)
};

const fr_verify_email_button = /** @type {(inputs: Verify_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérifier l’adresse e-mail`)
};

const hr_verify_email_button = /** @type {(inputs: Verify_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potvrdite e-mail adresu`)
};

const it_verify_email_button = /** @type {(inputs: Verify_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifica indirizzo email`)
};

const lv_verify_email_button = /** @type {(inputs: Verify_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apstiprināt e-pasta adresi`)
};

const lt_verify_email_button = /** @type {(inputs: Verify_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Patvirtinti el. pašto adresą`)
};

const hu_verify_email_button = /** @type {(inputs: Verify_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail cím ellenőrzése`)
};

const nl_verify_email_button = /** @type {(inputs: Verify_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mailadres bevestigen`)
};

const nb_verify_email_button = /** @type {(inputs: Verify_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekreft e-postadressen`)
};

const pl_verify_email_button = /** @type {(inputs: Verify_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zweryfikuj adres e-mail`)
};

const pt_verify_email_button = /** @type {(inputs: Verify_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirmar endereço de e-mail`)
};

const ro_verify_email_button = /** @type {(inputs: Verify_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se verifică adresa de e-mail`)
};

const sk_verify_email_button = /** @type {(inputs: Verify_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Overiť emailovú adresu`)
};

const sl_verify_email_button = /** @type {(inputs: Verify_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Potrdi e-naslov`)
};

const fi_verify_email_button = /** @type {(inputs: Verify_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vahvista sähköpostiosoite`)
};

const sv_verify_email_button = /** @type {(inputs: Verify_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifiera e-postadressen`)
};

const vi_verify_email_button = /** @type {(inputs: Verify_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xác minh địa chỉ email`)
};

const tr_verify_email_button = /** @type {(inputs: Verify_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-posta adresini doğrulayın`)
};

const el_verify_email_button = /** @type {(inputs: Verify_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Επαληθεύστε τη διεύθυνση email`)
};

const bg_verify_email_button = /** @type {(inputs: Verify_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Потвърди имейл адреса си`)
};

const ru_verify_email_button = /** @type {(inputs: Verify_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подтвердить адрес электронной почты`)
};

const sr_verify_email_button = /** @type {(inputs: Verify_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Верификуј имејл адресу`)
};

const uk_verify_email_button = /** @type {(inputs: Verify_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Підтвердіть вашу електронну адресу`)
};

const ka_verify_email_button = /** @type {(inputs: Verify_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ელექტრონული ფოსტის დადასტურება`)
};

const hi_verify_email_button = /** @type {(inputs: Verify_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ईमेल एड्रेस वेरीफाई करें`)
};

const th_verify_email_button = /** @type {(inputs: Verify_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ตรวจสอบที่อยู่อีเมล`)
};

const ko_verify_email_button = /** @type {(inputs: Verify_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이메일 주소 확인`)
};

const zh_verify_email_button = /** @type {(inputs: Verify_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`验证电子邮件地址`)
};

const zh_tw_verify_email_button = /** @type {(inputs: Verify_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`驗證電子郵件地址`)
};

const ja_verify_email_button = /** @type {(inputs: Verify_Email_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メールアドレスを確認`)
};

/**
* | output |
* | --- |
* | "Verify email address" |
*
* @param {Verify_Email_ButtonInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const verify_email_button = /** @type {((inputs?: Verify_Email_ButtonInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Verify_Email_ButtonInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_verify_email_button(inputs)
	if (locale === "ms") return ms_verify_email_button(inputs)
	if (locale === "ca") return ca_verify_email_button(inputs)
	if (locale === "cs") return cs_verify_email_button(inputs)
	if (locale === "da") return da_verify_email_button(inputs)
	if (locale === "de") return de_verify_email_button(inputs)
	if (locale === "et") return et_verify_email_button(inputs)
	if (locale === "es") return es_verify_email_button(inputs)
	if (locale === "fr") return fr_verify_email_button(inputs)
	if (locale === "hr") return hr_verify_email_button(inputs)
	if (locale === "it") return it_verify_email_button(inputs)
	if (locale === "lv") return lv_verify_email_button(inputs)
	if (locale === "lt") return lt_verify_email_button(inputs)
	if (locale === "hu") return hu_verify_email_button(inputs)
	if (locale === "nl") return nl_verify_email_button(inputs)
	if (locale === "nb") return nb_verify_email_button(inputs)
	if (locale === "pl") return pl_verify_email_button(inputs)
	if (locale === "pt") return pt_verify_email_button(inputs)
	if (locale === "ro") return ro_verify_email_button(inputs)
	if (locale === "sk") return sk_verify_email_button(inputs)
	if (locale === "sl") return sl_verify_email_button(inputs)
	if (locale === "fi") return fi_verify_email_button(inputs)
	if (locale === "sv") return sv_verify_email_button(inputs)
	if (locale === "vi") return vi_verify_email_button(inputs)
	if (locale === "tr") return tr_verify_email_button(inputs)
	if (locale === "el") return el_verify_email_button(inputs)
	if (locale === "bg") return bg_verify_email_button(inputs)
	if (locale === "ru") return ru_verify_email_button(inputs)
	if (locale === "sr") return sr_verify_email_button(inputs)
	if (locale === "uk") return uk_verify_email_button(inputs)
	if (locale === "ka") return ka_verify_email_button(inputs)
	if (locale === "hi") return hi_verify_email_button(inputs)
	if (locale === "th") return th_verify_email_button(inputs)
	if (locale === "ko") return ko_verify_email_button(inputs)
	if (locale === "zh") return zh_verify_email_button(inputs)
	if (locale === "zh-tw") return zh_tw_verify_email_button(inputs)
	if (locale === "ja") return ja_verify_email_button(inputs)
	return en_verify_email_button(inputs)
});